import * as a from './adapters';

export { default as Adapter } from './adapter';
export const adapters = a;



// WEBPACK FOOTER //
// ./adapters/index.js